// extracted by extract-css-chunks-webpack-plugin
module.exports = {"warning":"#f8d13a","greyLight":"#b5b5b5","wrapper":"ModalCard_wrapper-3j3A3","side":"ModalCard_side-dswhH","contentWrapper":"ModalCard_contentWrapper-MWF6E"};